import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import getStateManager from '../StateManager';
import { useTabSettings, writeTempSettings } from '../Tabs/settingFunctions';
import { migrateCo2SettingsDraft, supportsCo2SettingsRelocation } from '../Utils/co2_utils';

// Climate, Ventilation and CO2 share the draft migration when ownership moves.
export function useCo2Settings() {
  const params = useParams();
  const { controller, parent } = getStateManager().getControllerForTab(params);
  const relocated = supportsCo2SettingsRelocation(controller);
  // Register before useTabSettings so migration precedes its draft restoration.
  useEffect(() => {
    if (migrateCo2SettingsDraft(controller, parent)) writeTempSettings(parent);
  }, [controller, parent, relocated]);
  return useTabSettings();
}
